module.exports = __webpack_public_path__ + "img/jc-yjy.4f407e24.jpg";